import { useContext } from "react";
import { HouseContext } from "../../context/HouseContext";
import { AlquileresContext } from "../../context/AlquileresContext";
import LoadingState from "./LoadingState";

// Wraps the dashboard home page. Waits for BOTH contexts to finish their
// initial fetch -- the home shows summary cards from properties and rentals.
function DashboardLoadingGuard({ children }) {
  const { initialLoaded: housesLoaded } = useContext(HouseContext);
  const { initialLoaded: alquileresLoaded } = useContext(AlquileresContext);
  if (!housesLoaded || !alquileresLoaded) {
    return <LoadingState message="Cargando dashboard..." />;
  }
  return children;
}

export default DashboardLoadingGuard;
